import { showApiError, showSuccess } from "@/lib/toast";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateFirm } from "@/sideEffects/api";
import { FirmDetails } from "@/lib/types";
import { FirmMetaForm, FormSchemaType } from "../form/FirmMetaForm";

interface Props {
  firmDetails: FirmDetails;
}

export const UpdateFirmMetaForm: React.FC<Props> = ({ firmDetails }) => {
  const { t } = useTranslation();

  const queryClient = useQueryClient();
  const updateFirmMutation = useMutation({
    mutationFn: (values: FormSchemaType) =>
      updateFirm({
        id: firmDetails.id,
        name: values.name,
        systemUsername: values.systemUsername,
        systemPassword: values.systemPassword,
        systemEndPoint: values.systemEndPoint,
        customerKey: values.customerKey,
        apiMenu: values.apiMenu ?? false,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["getFirm"],
      });
      queryClient.invalidateQueries({
        queryKey: ["getFirmDetails", firmDetails.id],
      });
      showSuccess(t("common.updatedSuccess"));
    },
    onError: showApiError,
  });

  return (
    <>
      <FirmMetaForm
        buttonText={t("common.update")}
        onSubmit={(values) => updateFirmMutation.mutate(values)}
        isLoading={updateFirmMutation.isPending}
        defaultValues={{
          name: firmDetails.name ?? "",
          systemUsername: firmDetails.systemUsername ?? "",
          systemPassword: firmDetails.systemPassword ?? "",
          systemEndPoint: firmDetails.systemEndPoint ?? "",
          customerKey: firmDetails.customerKey ?? "",
          apiMenu: firmDetails.apiMenu ?? false,
        }}
        showApiMenu={true}
        showStats={true}
        stats={{
          totalUsers: firmDetails.totalUsers,
          totalContent: firmDetails.totalContent,
          totalContentGroup: firmDetails.totalContentGroup,
        }}
      />
    </>
  );
};
